export default __webpack_public_path__ + "static/amico-1-17adb076f2775dce9da86d78f1da181c.png";